<button *ngIf="isAvalaible()" type="button" class="btn list-tools" (click)="download()"
        placement="left"
        [ngbTooltip]="'DOWNLOAD_JSON_CONFIG' | translate">
    <app-progressbar *ngIf="showSpinner"></app-progressbar>
    <fa-icon [icon]="faCloudDownloadAlt"></fa-icon>

</button>